import React from 'react';
import "../../styles/global-hero.css";

const Hero = () => {
    return (
        <div className="global-hero">
            <div className="container text-center">
                <h1>38<sup>th</sup> Convocation</h1>
                <p>Home &gt; 38th Convocation</p>
            </div>
        </div>
    )
}

export default Hero;